export default "__VITE_ASSET__vQFVRvpV__"